import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
  CircularProgress,
} from "@mui/material";

const DeleteMemberModal = ({ open, onClose, onDelete, member }) => {
  const [confirmation, setConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  if (!member) return null;

  const handleDelete = async () => {
    if (confirmation.toLowerCase() !== "borrar") return;
    try {
      setLoading(true);
      await onDelete(member.id); // Assuming member.id holds the Firestore document ID
      setSuccess(true);
      setConfirmation("");
    } catch (err) {
      console.error("Error al borrar el miembro:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Borrar Miembro</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          ¿Estás seguro que deseas borrar al miembro:
        </Typography>
        <Typography variant="h6" color="error">
          {member.NOMBRE_APELLIDO}
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Escribí <strong>“borrar”</strong> para confirmar.
        </Typography>
        <TextField
          fullWidth
          margin="normal"
          variant="outlined"
          value={confirmation}
          onChange={(e) => setConfirmation(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={confirmation.toLowerCase() !== "borrar"}
        >
          Confirmar Borrado
        </Button>
      </DialogActions>
      {loading && (
        <Box textAlign="center" my={2}>
          <CircularProgress size={24} />
          <Typography variant="body2" mt={1}>Borrando...</Typography>
        </Box>
      )}
      {success && (
        <Typography variant="body2" color="success.main" textAlign="center" mt={2}>
          Miembro borrado exitosamente.
        </Typography>
      )}
      {error && (
        <Typography variant="body2" color="error.main" textAlign="center" mt={2}>
          Error al borrar el miembro. Intenta nuevamente.
        </Typography>
      )}
    </Dialog>
  );
};

export default DeleteMemberModal;